import React from 'react';

import { LomavisCampaignText1 } from '@/lomavisSharedUi/atoms/typography/LomavisCampaignText1';

export interface LomavisCampaignSectionHeader1Props {
  number?: string;
  title: string;
  description: string;
  className?: string;
  iconClass?: string;
}

export const LomavisCampaignSectionHeader1: React.FC<
  LomavisCampaignSectionHeader1Props
> = ({ number, title, description, className = '', iconClass }) => (
  <div className={`vstack gap-1 ${className}`}>
    {number && (
      <LomavisCampaignText1 variant="sectionNumber">
        {number}
      </LomavisCampaignText1>
    )}
    <LomavisCampaignText1
      variant="sectionTitle"
      className={number ? 'mt-1' : undefined}
    >
      <span className="d-inline-flex align-items-center gap-2">
        {iconClass ? <i className={iconClass} aria-hidden="true" /> : null}
        <span>{title}</span>
      </span>
    </LomavisCampaignText1>
    <LomavisCampaignText1 variant="helper">
      {description}
    </LomavisCampaignText1>
  </div>
);
